var _circle, _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 50,
    fill: "#FFD951"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 50,
    fill: "url(#paint0_radial)",
    style: {
      mixBlendMode: "darken"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M86.0672 39.6203C86.6242 39.9747 87.3837 39.5696 87.3837 38.8987V38.8861C87.3837 34.8861 84.1432 31.6456 80.1432 31.6456C76.1432 31.6456 72.9027 34.8861 72.9027 38.8861V38.8987C72.9027 39.5696 73.6495 39.962 74.2191 39.6203C75.9406 38.557 77.9659 37.9367 80.1432 37.9367C82.3204 37.9367 84.3457 38.557 86.0672 39.6203Z",
    fill: "#030822"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4722 39.6198C26.0418 39.9742 26.7886 39.5692 26.7886 38.8983V38.8856C26.7886 34.8856 23.5481 31.6451 19.5481 31.6451C15.5481 31.6451 12.3076 34.8856 12.3076 38.8856V38.8983C12.3076 39.5692 13.0545 39.9616 13.6241 39.6198C15.3456 38.5565 17.3709 37.9363 19.5355 37.9363C21.7254 37.9363 23.7507 38.5565 25.4722 39.6198Z",
    fill: "#030822"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8389 54.9743C20.0921 55.5692 19.0921 57.468 19.7756 59.1895C23.8516 69.5186 35.8136 78.2148 49.8516 78.2148C63.8895 78.2148 75.8516 69.5186 79.9275 59.1895C80.5984 57.468 79.6111 55.5692 77.8642 54.9743C60.9402 49.2528 38.763 49.2528 21.8389 54.9743Z",
    fill: "#030822"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(56.25 40.7692) rotate(96.0235) scale(59.5596 59.5396)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.854067,
    stopColor: "#FFBB54",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.854167,
    stopColor: "#FFDA54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.854267,
    stopColor: "#FFBB54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979167,
    stopColor: "#FFBB54"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreat);
export default __webpack_public_path__ + "static/media/Great.cdf08a5213b6a2b0d4b26b2719f7762d.svg";
export { ForwardRef as ReactComponent };